import { Component, Input, ViewChild } from '@angular/core';
import { ConfiguracionActividadesService } from '../../../../../services/database/pqrsd/configuracion-actividades.service';
import { ConfiguracionActividadDto, IGetActividades, IGetActividadesConfiguracion } from '../../../../../shared/interfaces/database/pqrsd';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, IFooterColums, IHeader, LoadingPanelService, LocalService, Utils } from 'lib-base';
import { CommonModule } from '@angular/common';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TiposService } from '../../../../../services/database/pqrsd/tipos.service';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { ActividadesService } from '../../../../../services/database/pqrsd/actividades.service';
import { PqrdsConfigActividadHistoricoComponent } from './pqrds-config-act-historico/pqrds-config-act-historico.component';

@Component({
  selector: 'app-pqrds-configuracion-actividades-by-tipo',
  standalone: true,
  imports: [CommonModule, CustomTableComponent, ConfirmPopupModule, FormsModule, DialogModule, DropdownModule, InputNumberModule, CustomTitle,
    FormGroupErrorMessageComponent, ReactiveFormsModule, ButtonModule, PqrdsConfigActividadHistoricoComponent
  ],
  providers: [ConfirmationService],
  templateUrl: './pqrds-configuracion-actividades-by-tipo.component.html',
  styleUrl: './pqrds-configuracion-actividades-by-tipo.component.scss'
})
export class PqrdsConfiguracionActividadesByTipoComponent {
  @Input() tipoId!: number;
  @Input() plazo!: number;

  //table actividades
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  role = AccessRole;
  trans: any = {};
  btnGuardarDisable: boolean = true;
  dataset !: IGetActividadesConfiguracion[];

  //Form modal
  formTitle = '';
  displayModal = false;
  form !: FormGroup;
  private _editValue !: IGetActividadesConfiguracion | undefined;
  private originalValues: any;
  actividades !: IGetActividades[];

  @ViewChild(PqrdsConfigActividadHistoricoComponent) historico !: PqrdsConfigActividadHistoricoComponent;

  constructor(private readonly _cas: ConfiguracionActividadesService, private readonly _lps: LoadingPanelService, private readonly _t: TranslateService,
    readonly ls: LocalService, private readonly _ts: TiposService, private readonly _ms: MessageService, private readonly _fb: FormBuilder,
    private readonly _ac: ActividadesService, private readonly _cs: ConfirmationService
  ) {
    this.configureForm();
  }

  ngOnInit(): void {
    this.translate().then(() => {
      this.configurarTabla();
    });
    this.getActividadesConfiguracion();
  }

  get isNewForm(): boolean {
    return this._editValue === undefined;
  }

  get data(): IGetActividadesConfiguracion[] {
    return this.customTableComponent.data;
  }

  set data(value: IGetActividadesConfiguracion[]) {
    this.customTableComponent.data = value;
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      actividades: this._t.get('common.actividades'),
      actividad: this._t.get('common.actividad'),
      tipo: this._t.get('common.tipo'),
      orden: this._t.get('common.orden'),
      plazoFechaCierre: this._t.get('common.plazoFechaCierre'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad'),
      limpiar: this._t.get('form.button.limpiar'),
      guardar: this._t.get('form.button.guardar'),
      cancelar: this._t.get('form.button.cancelar'),
      nuevaActividad: this._t.get('msg.nuevaActividad'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      actividadesGuardadas: this._t.get('msg.actividadesGuardadas'),
      advertencia: this._t.get('common.advertencia'),
    }));
  }

  private configurarTabla() {
    this.customTable = {

      columns: [
        {
          field: 'actividad',
          header: this.trans.actividad,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'orden',
          header: this.trans.orden,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'plazoFechaCierre',
          header: this.trans.plazoFechaCierre,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_PQRSD),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: IGetActividadesConfiguracion) => this.openEditModal(data),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-1',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorial(),
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          onClick: (event: Event, data: IGetActividadesConfiguracion) => this.deleteConfirmation(event, data),
          disabled: !this.ls.hasRole(this.role.ADMIN_PQRSD),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_PQRSD),
          },
          headerTooltip: {
            message: this.trans.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_PQRSD)
          }
        }
      ],
      footer: [
        {
          dataType: DataColumnType.NONE
        },
        {
          dataType: DataColumnType.NONE
        },
        {
          dataType: DataColumnType.TEXT,
          class: 'text-center',
          getValue: () => this.getTotalPlazo()
        },
        {
          dataType: DataColumnType.NONE
        },
        {
          dataType: DataColumnType.NONE
        }
      ] as IFooterColums[],
      settings: {
        table: {
          rows: 5,
        }
      }
    } as ICustomTable;
  }

  private configureForm() {
    this.form = this._fb.group({
      actividadId: [null, [Validators.required]],
      orden: [null, [Validators.required, Validators.min(1)]],
      plazoFechaCierre: [null, [Validators.required, Validators.min(1)]],
    });
  }

  abrirHistorial(): void {
    this.historico.show(this.tipoId);
  }

  openLink() {
    window.open(`/#/configuracion/admin-pqrsd?tabIndex=1`, '_blank');
  }

  resetForm() {
    this.form.reset();
  }

  openNewModal() {
    this.resetForm();
    this.formTitle = this.trans.nuevaActividad;
    this._editValue = undefined;
    this.form.get('orden')?.setValue(this.data.length + 1);
    this.form.get('plazoFechaCierre')?.setValue(1);
    this.getActividades();
    this.displayModal = true;
  }

  openEditModal(value: IGetActividadesConfiguracion) {
    this.resetForm();
    this.formTitle = this.trans.editarCategoria;
    this._editValue = value;
    this.form.get('actividadId')?.setValue(value.actividadId);
    this.form.get('orden')?.setValue(value.orden);
    this.form.get('plazoFechaCierre')?.setValue(value.plazoFechaCierre);
    this.getActividades();
    this.displayModal = true;
    this.originalValues = { ...this.form.value };
  }

  deleteConfirmation(event: Event, data: IGetActividadesConfiguracion) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: 'Estas seguro de que quieres eliminar la actividad?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.removeActividad(data.actividadId);
      },
      reject: () => {

      }
    });
  }

  onSubmit() {
    if (this.form.pristine) {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    if (this.form.invalid) {
      Utils.markAllFormControlsAsTouched(this.form);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.completeCamposRequeridos });
      return;
    }

    let newValues = {
      actividadId: this.form.get('actividadId')?.value,
      orden: this.form.get('orden')?.value,
      opcional: this.form.get('opcional')?.value,
      plazoFechaCierre: this.form.get('plazoFechaCierre')?.value
    } as ConfiguracionActividadDto;

    if (this.isNewForm) {
      this.addActividad(newValues);
    } else if (!Utils.isDeepEqual(this.originalValues, newValues)) {
      this.editActividad(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
    }

    this.btnGuardarDisable = false;
  }

  //#region Tabla
  private getTotalPlazo(): string {
    if (!this.data) return '0';
    return ` ${this.data.reduce((acc, curr) => acc + curr.plazoFechaCierre, 0).toString()} / ${this.plazo}`;
  }

  private addActividad(add: ConfiguracionActividadDto) {
    const actividad = this.actividades.find(a => a.id === add.actividadId);
    if (!actividad) return;

    let newTipoActividad = {
      id: this.generateTempId(),
      actividadId: actividad.id,
      actividad: actividad.descripcion,
      tipoId: -1,
      orden: add.orden,
      plazoFechaCierre: add.plazoFechaCierre
    } as IGetActividadesConfiguracion;

    this.data.push(newTipoActividad);

    this.displayModal = false;
    this.sortActividades(newTipoActividad.id);
  }

  private editActividad(update: ConfiguracionActividadDto) {
    let tipoActividad = this.data.find(t => t.id === this._editValue?.id);
    if (!tipoActividad) return;

    const actividad = this.actividades.find(a => a.id === update.actividadId);
    if (!actividad) return;

    tipoActividad.actividadId = actividad.id;
    tipoActividad.actividad = actividad.descripcion;
    tipoActividad.orden = update.orden;
    tipoActividad.plazoFechaCierre = update.plazoFechaCierre;

    this.displayModal = false;
    this.sortActividades(tipoActividad.id);
  }

  private removeActividad(id: number) {
    this.data = this.data.filter(t => t.actividadId !== id);
    let ordenIndex = 1;
    for (const data of this.data) {
      data.orden = ordenIndex;
      ordenIndex++;
    }
    this.btnGuardarDisable = false;
  }

  private generateTempId() {
    let tempId = -1;
    do {
      tempId = Math.floor(Math.random() * 10000); // Generate a random number between 0 and 999999
    } while (this.data.some(item => item.actividadId === tempId));
    return tempId;
  }

  private sortActividades(id: number) {
    let ordenIndex = 1;
    this.data.sort((a, b) => a.orden - b.orden);
    let newActividadUpdated: boolean = false;
    let updateActividad = this.data.find(t => t.id === id);
    if (!updateActividad) return;

    for (const actividadExistente of this.data) {

      if (updateActividad.id === actividadExistente.id) {
        continue;
      }

      if (!newActividadUpdated && updateActividad.orden <= ordenIndex) {
        updateActividad.orden = ordenIndex;
        ordenIndex++;
        newActividadUpdated = true;
      }
      actividadExistente.orden = ordenIndex;
      ordenIndex++;
    }
    if (!newActividadUpdated) {
      updateActividad.orden = ordenIndex;
    }
    this.data.sort((a, b) => a.orden - b.orden);
  }

  onGuardarCambios() {
    const request: ConfiguracionActividadDto[] = this.data.map(t => ({
      actividadId: t.actividadId,
      orden: t.orden,
      plazoFechaCierre: t.plazoFechaCierre
    }));

    this.editarActividades(request);
    this.btnGuardarDisable = true;
  }

  onCancelarCambios() {
    this.data = this.dataset;
    this.btnGuardarDisable = true;
  }

  //#endregion

  //#region API Calls
  private getActividadesConfiguracion(): void {
    this._cas.getActividadesConfiguracion(this.tipoId).subscribe({
      next: (data: IGetActividadesConfiguracion[]) => {
        //guardamos un clon para tener un punto de retorno en caso de cancelar los cambios
        this.dataset = structuredClone(data);
        this.data = structuredClone(data);
      },
    });
  }

  private editarActividades(request: ConfiguracionActividadDto[]) {
    this._lps.show(true);
    this._ts.editarActividades(this.tipoId, request).subscribe({
      next: (data: boolean) => {
        this._lps.hide();
        this.getActividadesConfiguracion();
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.actividadesGuardadas });
      }
    });
  }

  getActividades() {
    this.actividades = [];
    this._ac.getActividades().subscribe({
      next: (actividades: IGetActividades[]) => {
        this.actividades = actividades.filter(a =>
          !this.data.some(t => t.actividadId === a.id) || (this._editValue && a.id === this._editValue.actividadId)
        );
      }
    });

  }
  //#endregion
}
